<script>
  export let profile = null;
  import ContentPage from "./ContentPage.svelte";
  import AboutContent from "./Content/AboutContent.svelte";
</script>

<ContentPage profile="{profile}" title="About" content="{AboutContent}" />
